// Event-only alerts: queue snapshots (initial load/reconnect/polling) never
// generate notifications. Keep IDs for the lifetime of this operator screen.
export function createQueueArrivalGuard(orgId: string) {
  const seen = new Set<string>();
  return (event: string, payload: unknown, online: boolean): boolean => {
    if (event !== "session_new" || !payload || typeof payload !== "object") return false;
    const p = payload as Record<string, unknown>;
    if (p.organizationId !== orgId || typeof p.id !== "string" || !p.id || p.status !== "queued") return false;
    if (seen.has(p.id)) return false;
    seen.add(p.id); // Offline arrivals must not become alerts on a later retry.
    return online;
  };
}
